import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { forgotPasswordRequest } from "../api/auth.api";
import "./Login.css";

const ForgetPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error("Veuillez entrer votre adresse email");
            return;
        }

        setLoading(true);

        try {
            const response = await forgotPasswordRequest(email);

            if (response.success) {
                toast.success(response.message || "Un email de réinitialisation a été envoyé");
                setEmail(""); 
            } else {
                toast.error(response.message || "Erreur lors de l'envoi");
            }

        } catch (err) {
            console.error("❌ Erreur forget password:", err);
            toast.error(err.message || "Impossible d'envoyer l'email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toaster position="top-right" richColors />
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <div className="login-icon-wrapper">
                            <svg className="login-svg-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    strokeWidth={2} 
                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
                                />
                            </svg>
                        </div>
                        <h1 className="login-title">Mot de passe oublié</h1>
                        <p className="login-description">
                            Entrez votre adresse email pour recevoir un lien de réinitialisation.
                        </p>
                    </div>

                    <div className="login-content">
                        <form onSubmit={handleSubmit} className="login-form">
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">
                                    Adresse email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="form-input"
                                    placeholder="votre@email.com"
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="submit-btn"
                            >
                                {loading ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin"></i>
                                        Envoi en cours...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-envelope"></i>
                                        Envoyer le lien
                                    </>
                                )}
                            </button>

                            <div className="login-footer">
                                <p className="footer-text">
                                    Vous vous souvenez de votre mot de passe ?{" "}
                                    <Link to="/login" className="register-link">
                                        Se connecter
                                    </Link>
                                </p>
                                <Link to="/" className="home-link">
                                    <i className="fas fa-home"></i>
                                    Retour à l'accueil
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgetPassword;